<template>
  <v-footer dark :padless="padless" relative class="my-0 py-0">
    <v-card
      flat
      tile
      width="100%"
      class="indigo lighten-1 white--text text-center "
    >
      <v-card-text>
        <v-btn v-for="icon in icons" :key="icon" class="mx-4 white--text" icon>
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        <H3>{{ slogan }} </H3>
        <H3>{{ devise }}</H3>
        <v-spacer></v-spacer>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        <h3>
          <span class="font-weight-bold"> ტელეფონი:</span>
          <a href="tel:995577109022">{{ telefon }}</a>
        </h3>
        <h3>
          <span class="font-weight-bold">ელ-ფოსტა:</span
          ><a href="mailto:bnm.ltd.ge@gmail.com"> {{ email }}</a>
        </h3>
        <h3><span class="font-weight-bold">მისამართი:</span> {{ address }}</h3>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Shota Tsiklauri</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>
<script>
// eslint fixing
// npm run lint -- --fix
export default {
  data: () => ({
    icons: [
      "fa fa-facebook",
      "fa fa-twitter",
      "fa fa-google-plus",
      "fa fa-linkedin",
      "fa fa-instagram"
    ],
    padless: true,
    slogan: "ჩამოგიტანთ, მაღალი ხარისხის ევროპულ ზეთებს დაბალი დანახარჯით.",
    devise: "იზრუნეთ თქვენს ტექნიკაზე!",
    name: "შპს BNM",
    telefon: "+995577109022",
    email: "bnm.ltd.ge@gmail.com",
    address: "დუშეთის მუნიციპალიტეტი, სოფელი მაღრანი"
  })
};
</script>

<style scoped>
a[href^="tel:"] {
  color: rgb(252, 252, 252);
  text-decoration: none;
  padding-left: 1em;
}
a[href^="mailto:"] {
  color: rgb(252, 252, 252);
  text-decoration: none;
  padding-left: 1em;
}
</style>
